import React from 'react';

// Define the type for the props
interface TicketCardProps {
  category: string;
  ticketCount: number;
  badgeColor: string;
  icon: string;
}

const TicketCard: React.FC<TicketCardProps> = ({
  category,
  ticketCount,
  badgeColor,
  icon,
}) => {
  return (
    <div className="col-xl-3 col-md-6 d-flex">
      <div className="card flex-fill">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className={`flex-shrink-0 me-2 p-2 br-10 bg-transparent border ${badgeColor} d-flex align-items-center justify-content-center`}>
                <i className={`${icon} fs-18`} />
              </div>
              <div>
                <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">{category}</p>
                <h4>{ticketCount}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketCard;
